import { INCLUSION_EDGE_TYPE } from "config/constants";
import Log from "utils/log";

/**
 * Based on examples from:
 * https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-fetchMore
 * https://www.apollographql.com/docs/react/features/pagination.html
 */

/**
 * @param {function} fetchMore - a fetchMore function passed from a <Query> component's render props
 * @param {bool} pageInfo.hasNextPage - does the current page have a following page
 * @param {integer} pageInfo.page - current page number
 */
export default function streamFetchMore(fetchMore, pageInfo) {
  if (!pageInfo.hasNextPage) {
    return;
  }

  return fetchMore({
    variables: { page: pageInfo.page + 1 },
    updateQuery: updateQueryWithNewPage,
  });
}

/**
 * @param {object} previousResult - the previous result of the query
 * @param {object} fetchMoreResult - result of fetching with new variables
 */
export function updateQueryWithNewPage(previousResult, { fetchMoreResult }) {
  const oldEdges = previousResult.stream.streamInclusionConnection.edges;
  const oldEdgeIds = oldEdges.map(edge => edge.node.id);
  const newEdgeIds = fetchMoreResult.stream.streamInclusionConnection.edges.map(
    edge => edge.node.id
  );
  const newEdges = fetchMoreResult.stream.streamInclusionConnection.edges
    .filter(
      (edge, index) =>
        !oldEdgeIds.includes(edge.node.id) &&
        newEdgeIds.indexOf(edge.node.id) === index
    )
    .filter((edge, index, array) => {
      // prevent two ads from being next to each other if we remove a lot of dupes
      if (
        index &&
        edge.__typename === INCLUSION_EDGE_TYPE.AD &&
        array[index - 1].__typename === INCLUSION_EDGE_TYPE.AD
      ) {
        return false;
      }
      return true;
    });
  const newPageInfo = fetchMoreResult.stream.streamInclusionConnection.pageInfo;

  if (newEdges.length !== newEdgeIds.length) {
    const duplicateIds = oldEdgeIds.filter(id => newEdgeIds.includes(id));
    Log.logger(`${duplicateIds.length} duplicate edges removed`, "warning", {
      oldEdgeIds,
      newEdgeIds,
      duplicateIds,
      page: newPageInfo.page,
      lookup: fetchMoreResult.stream.lookup,
      displayName: fetchMoreResult.stream.displayName,
    });
  }

  return newEdges.length
    ? {
        stream: {
          ...previousResult.stream,
          streamInclusionConnection: {
            ...previousResult.stream.streamInclusionConnection,
            edges: [...oldEdges, ...newEdges],
            pageInfo: newPageInfo,
          },
        },
      }
    : previousResult;
}
